<template>
  <div class="work-logs">
    <div class="menu">
      <div>
        <div class="btn-group btn-group-sm">
          <router-link :to="linkToday" class="btn btn-secondary">
            Today
          </router-link>
          <router-link :to="linkPrev" class="btn btn-secondary">
            <i class="fa fa-chevron-left"></i>
          </router-link>
          <router-link :to="linkNext" class="btn btn-secondary">
            <i class="fa fa-chevron-right"></i>
          </router-link>
        </div>
        <div class="btn-group btn-group-sm">
          <router-link :to="`/list/${slug}`" class="btn btn-secondary" :class="{active: layout === 'list'}">
            List
          </router-link>
          <router-link :to="`/week/${slug}`" class="btn btn-secondary" :class="{active: layout === 'week'}">
            Calendar
          </router-link>
        </div>
        <i class="fa fa-spin fa-circle-o-notch" v-if="loading"></i>
      </div>
      <div>
        <div class="btn-group btn-group-sm" v-if="canLogWork">
          <a class="btn btn-primary" href="/work-logs/add">Log work</a>
          <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#commitModal">
            Commit work
          </button>
        </div>
        <small class="pt-2 pl-2">
          Current lock time: {{currentLockTime}}
        </small>
      </div>
      <Modal ref="modal" :currentLockTime="currentLockTime" />
    </div>
    <Filters
      :users="users"
      :projects="projects"
      @select="updateFilters"
      ref="filters"
    />
    {{weekSummary}}
    
    <div class="row">
      <div class="col-md">
        <List :logs="filteredLogs" :selected-log="selectedLog" @select-log="updateSelectedLog" v-if="layout === 'list'"/>
        <Week :logs="filteredLogs" :selected-log="selectedLog" :slug="slug" @select-log="updateSelectedLog" v-if="layout === 'week'"/>
      </div>

      <div :class="selectedLogFloating ? '' : 'col-md'" v-if="selectedLog">
        <SelectedLog
          :log="selectedLog"
          :position="selectedLogPosition"
          @close="selectedLog = null"
          @position="updateSelectedLogPosition"
          :floating="selectedLogFloating"
          @float="selectedLogFloating = true"
          @dock="selectedLogFloating = false"
        />
      </div>
    </div>
  </div>
  
</template>

<script>
 import toDate from 'date-fns/toDate';
 import subSeconds from 'date-fns/subSeconds';
 import subWeeks from 'date-fns/subWeeks';
 import addWeeks from 'date-fns/addWeeks';
 import addDays from 'date-fns/addDays';
 import parse from 'date-fns/parse';
 import startOfWeek from 'date-fns/startOfWeek';
 import formatDate from 'date-fns/format';
 import isWithinInterval from 'date-fns/isWithinInterval';
 import axios from 'axios';
 import Vue from 'vue';
 import {showError} from 'perform-base/js/flashes';

 import Filters from './Filters';
 import List from './List';
 import Week from './Week';
 import Modal from './Modal';
 import SelectedLog from './SelectedLog';

 export default {
   props: [
     // e.g. 2019-07-01
     'slug',
     'currentLockTime',
     'canLogWork',
     'layout',
   ],
   data() {
     return {
       logs: [],
       users: [],
       projects: [],
       selectedUsers: [],
       selectedProjects: [],
       loading: false,
       selectedLog: null,
       selectedLogPosition: null,
       selectedLogFloating: false,
     }
   },
   computed: {
     weekSummary() {
       const start = startOfWeek(this.currentDate, {
         weekStartsOn: 1
       });
       const end = addDays(start, 6);

       return `${formatDate(start, 'D MMM')} - ${formatDate(end, 'D MMM')}`;
     },
     currentDate() {
       return parse(this.slug, 'YYYY-MM-DD', new Date());
     },
     filteredLogs() {
       return this.logs.filter((log) => {
         if (this.selectedUsers.indexOf(log.user.id) === -1) {
           return false;
         }
         if (this.selectedProjects.indexOf(log.project.id) === -1) {
           return false;
         }
         return true;
       });
     },
     linkToday() {
       return `/${this.layout}/`+formatDate(new Date(), 'YYYY-MM-DD');
     },
     linkNext() {
       const next = addWeeks(this.currentDate, 1);
       return `/${this.layout}/`+formatDate(next, 'YYYY-MM-DD');
     },
     linkPrev() {
       const prev = subWeeks(this.currentDate, 1);
       return `/${this.layout}/`+formatDate(prev, 'YYYY-MM-DD');
     },
     startEnd() {
       return function(log) {
         return [start, end];
       }
     },
   },
   watch: {
     slug() {
       const allUsersWereActive = this.$refs.filters.allUsersActive;
       const allProjectsWereActive = this.$refs.filters.allProjectsActive;
       let cb = () => {
         Vue.nextTick(() => {
           if (allUsersWereActive) {
             this.$refs.filters.selectAllUsers();
           }
           if (allProjectsWereActive) {
             this.$refs.filters.selectAllProjects();
           }
         });
       }
       this.loadItems(cb);
     },
   },

   components: {
     SelectedLog,
     Filters,
     List,
     Week,
     Modal,
   },

   created() {
     this.loadItems(() => {
       Vue.nextTick(() => {
         this.$refs.filters.updateFromCookie();
       });
     });
   },

   methods: {
     loadItems(cb) {
       this.loading = true;
       axios
         .get('/api/work-logs/week/'+this.slug)
         .then(response => {
           this.logs = response.data.logs;
           this.users = response.data.users;
           this.projects = response.data.projects;
           if (cb) {
             cb();
           }
         }).catch((error) => {
           console.error(error);
           showError('An error occurred fetching work logs. Please reload the page to try again.');
         }).finally(() => {
           this.loading = false;
         });
     },
     updateSelectedLog(data) {
       this.selectedLog = data.selectedLog;
     },
     updateFilters(data) {
       this.selectedUsers = data.users;
       this.selectedProjects = data.projects;
     },
     updateSelectedLogPosition(position) {
       this.selectedLogPosition = position;
     },
   }
 }
</script>



// WEBPACK FOOTER //
// assets/js/components/work-logs/App.vue